import React from "react";
import Loader from "components/UI/Loader/Loader";

const ScreenLoader = () => (
    <div className="loader-screen">
        <Loader/>
    </div>
);

export default ScreenLoader;